/**
 * Employee Web — `/verify/$token`: the PUBLIC letter-verification page the QR
 * on a printed letter points at. Sits at the ROOT of the route tree (sibling
 * of `/login`, NOT under `_auth`) — no session, no tenant context.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { VerifyLetterPage } from "../features/verify/VerifyLetterPage";

export const Route = createFileRoute("/verify/$token")({
  component: VerifyRouteComponent,
});

function VerifyRouteComponent(): JSX.Element {
  const { token } = Route.useParams();
  return <VerifyLetterPage token={token} />;
}
